webpackJsonp([7],{

/***/ "+6/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0+am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification@2x.b42e1c6.png";

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2oQW":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("+6/G")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RHTv"),
  /* template */
  __webpack_require__("8j0L"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f5a0dc6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3Jun":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cooperation.40575e9.jpg";

/***/ }),

/***/ "4OLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("2oQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons_utils__ = __webpack_require__("j+bc");







var vm = null;

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
  window.JIN10_APP.VueComponents(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);
  vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a },
    template: '<App/>',
    store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
    el: '#J_ushk'
  });
};

if (false) {
  window.Vue = Vue;
  addScript('//cdn.jin10.com/assets/js/vue-components/js/index.js', function () {
    init();
  });
} else {
  init();
}

/***/ }),

/***/ "4R6w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-1.df1ecde.png";

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("4OLX");


/***/ }),

/***/ "8j0L":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk ushk-article",
    attrs: {
      "id": "J_ushk"
    }
  }, [_c('div', {
    staticClass: "ushk-container"
  }, [_c('div', {
    staticClass: "ushk-box"
  }, [_c('ushk-header'), _vm._v(" "), _c('div', {
    staticClass: "ushk-page"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('home')], 1)])], 1), _vm._v(" "), _c('ushk-footer')], 1), _vm._v(" "), _c('backtop')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "9eTL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-3.8d38244.png";

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USER; });
var UPDATE_USER = 'UPDATE_USER';

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_video__ = __webpack_require__("qLZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_calendar__ = __webpack_require__("Tmzm");









if (false) {
  Vue.use(Vuex);
}

var state = {
  user: {},
  isVideoPlaying: false,
  videoType: 'index'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_5__modules_home__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_6__modules_video__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_7__modules_calendar__["a" /* default */]
  }
}));

/***/ }),

/***/ "MA7u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accessData.501faa3.jpg";

/***/ }),

/***/ "RHTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home__ = __webpack_require__("UBPv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_home__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appStatic',
  computed: {},
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__pages_home___default.a
  },
  created: function created() {}
});

/***/ }),

/***/ "Tmzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_headers__ = __webpack_require__("+mDD");





var state = {
  stockAffect: {}
};

var getters = {
  stockAffect: function stockAffect(state) {
    return state.stockAffect;
  }
};

var actions = {
  getStockAffect: function getStockAffect(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    console.log(date);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
        url: __WEBPACK_IMPORTED_MODULE_2__commons_config__["a" /* requestUrl */].rili.stockAffect,
        params: {
          date: date
        },
        headers: __WEBPACK_IMPORTED_MODULE_3__commons_headers__["a" /* calendarHeaders */],
        type: 'GET',

        useJson: true,

        callback: function callback(_ref2) {
          var data = _ref2.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        success: function success(_ref3) {
          var data = _ref3.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        error: function error() {
          reject();
        }
      });
    });
  }
};

var mutations = {
  SET_STOCK_AFFECT: function SET_STOCK_AFFECT(state, data) {
    state.stockAffect = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "UBPv":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("ffIm")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("r4dr"),
  /* template */
  __webpack_require__("cHPu"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060df45e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadname", function() { return isReadname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVideoPlaying", function() { return isVideoPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "videoType", function() { return videoType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var user = function user(state) {
  return state.user;
};

var options = function options(state) {
  return state.options;
};

var isLogin = function isLogin(state) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.user).length;
};

var isReadname = function isReadname(state, getters) {
  return getters.isLogin && state.user.cert.name && state.user.cert.status === 1;
};

var isVideoPlaying = function isVideoPlaying(state) {
  return state.isVideoPlaying;
};

var videoType = function videoType(state) {
  return state.videoType;
};

/***/ }),

/***/ "Uq1x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan.fcb135b.png";

/***/ }),

/***/ "VwCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-sm.655b81d.png";

/***/ }),

/***/ "WfM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-calendar.f2fd14f.png";

/***/ }),

/***/ "ZQHk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-2.87e96ed.png";

/***/ }),

/***/ "cHPu":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "hd"
  }, [_vm._v("权限详情")]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', [_c('span', [_vm._v("存储")]), _vm._v("\n      开启存储权限，方便您下载和更新应用\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("照相机")]), _vm._v("\n      允许应用访问设备的日历数据。此权限用于应用展示日历相关功能\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("电话")]), _vm._v("\n      获取设备的标识\n    ")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("位置")]), _vm._v("\n      给用户精准推送消息\n    ")])])])
}]}

/***/ }),

/***/ "fTYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "feRo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng.4c9faf7.png";

/***/ }),

/***/ "ffIm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gBM3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan@2x.68a19e0.png";

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLogin", function() { return showLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");






var getUser = function getUser(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
      type: 'jsonp',
      url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].ucenterInfo,
      showError: false,
      success: function success(response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], response.data);
        resolve(response);
      },
      fail: function fail(response) {
        reject(response);
      }
    });
  });
};

var isShowLogin = false;
var showLogin = function showLogin(_ref2, type) {
  var commit = _ref2.commit;

  if (isShowLogin) {
    return false;
  }
  isShowLogin = true;
  setTimeout(function () {
    isShowLogin = false;
  }, 1000);
  type = type || 'login';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons__["a" /* showLoginBox */])({
      embedded: type === 'embedded',
      loginCallback: function loginCallback(datas) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], datas.data);
        resolve();
      },
      oauthCallback: function oauthCallback() {
        getUser({ commit: commit }).then(function () {
          resolve();
        });
      },

      type: type === 'embedded' ? 'login' : type
    });
  });
};

/***/ }),

/***/ "pNk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
});

/***/ }),

/***/ "qLZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");





var state = {

  list: [],
  isListEnd: false,
  orgList: []
};

var getters = {
  list: function list(state) {
    return state.list;
  },
  isListEnd: function isListEnd(state) {
    return state.isListEnd;
  }
};

var actions = {
  getList: function getList(_ref, _ref2) {
    var commit = _ref.commit;
    var page = _ref2.page,
        type = _ref2.type,
        onCompleted = _ref2.onCompleted;


    var me = this;

    if (page == 1) {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var url = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.list(page, type);

        window['JQ_3c42cf2edf105ad172a61c9eef7097cc'] = window['JQ_8dfb823cd98999b77e04d61deabdb4e4'] = window["JQ_2f906963abfa705c491a32911aa449ff"] = window['JQ_8a2783ae91350e5b3078ee73418dcf1e'] = function (data) {
          data.map(function (item) {

            item.isHover = false;
            item.isPlayer = false;
            item.lazyImage = "//cdn.jin10.com/assets/img/sites/video/lazy-bg.png";
            item.isShow = false;
            item.imgUrl2 = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.getEffect(item.id);
            item.isPause = true;
            item.isReset = false;
            item.isShowDesc = true;
            item.scrollTop = 0;
          });
          me.state.orgList = data;

          commit('getList', {
            data: data,
            page: page,
            onCompleted: onCompleted
          });

          resolve(data);
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["a" /* addScript */])(url, function (argument) {});
      });
    } else {
      commit('getList', {
        data: me.state.orgList,
        page: page,
        onCompleted: onCompleted
      });
    }
  }
};

var pageSize = 10;

var mutations = {
  getList: function getList(state, _ref3) {
    var data = _ref3.data,
        page = _ref3.page,
        onCompleted = _ref3.onCompleted;

    state.orgList = data;
    var newData = state.orgList.concat([]);

    if (page * pageSize >= state.orgList.length) {

      state.list = state.orgList;
      state.isListEnd = true;
    } else {
      newData.length = page * pageSize;
      state.list = newData;
      state.isListEnd = false;
    }

    if (onCompleted) {

      onCompleted(data);
    }
  },
  isItemShow: function isItemShow(state, index) {

    return state.list[index].isShow;
  },
  setItemShow: function setItemShow(state, index) {

    if (!state.list[index].isShow) {
      state.list[index].isShow = true;
    }
  },
  setItemScrollTop: function setItemScrollTop(state, _ref4) {
    var index = _ref4.index,
        scrollTop = _ref4.scrollTop;

    state.list[index].scrollTop = scrollTop;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qNZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification.1c5d039.png";

/***/ }),

/***/ "r4dr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons__ = __webpack_require__("N4+L");




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Home",
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_0__commons__["b" /* device */].isMobile) {
      new Jin10AppLauncher({
        openBlank: true,
        website: "futures"
      });
    }
  }
});

/***/ }),

/***/ "ufEw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-4.550c545.png";

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _types$UPDATE_USER$se;


/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER$se = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], function (state, datas) {
  state.user = datas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoState', function setVideoState(state, isVideoPlaying) {

  state.isVideoPlaying = isVideoPlaying;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoType', function setVideoType(state, type) {

  state.videoType = type;
}), _types$UPDATE_USER$se);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wTUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng@2x.828f805.png";

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ })

},[5]);


// WEBPACK FOOTER //
// static/js/permissions.67374891af83c61a8d88.js